import { render, staticRenderFns } from "./BaseTabContainer.vue?vue&type=template&id=314a1f23&scoped=true"
import script from "./BaseTabContainer.vue?vue&type=script&lang=js"
export * from "./BaseTabContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseTabContainer.vue?vue&type=style&index=0&id=314a1f23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a1f23",
  null
  
)

export default component.exports